export default __webpack_public_path__ + "static/media/event-graphic.e9b6dc14.png";